<template>
  <div class="mb-3 center">
    <span class="d-block" v-if="image && image.includes('data:image')">{{label}}</span>
    <a @click="chooseImage" href="#" v-if="image && image.includes('data:image')">
      <img :src="`${image || (isDisabled ? NoImage : NoImageUpload)}`"
        class="mr-3 ml-3"
        icon="user"
        rounded
        :class="isAcoutUser ? 'customs-image' : 'image'"
      />
    </a>
    <b-button @click="chooseImage" class="rounded" style="width: 10em; height: 10em" v-else>
      <b-icon font-scale="4" icon="upload"></b-icon>
    </b-button>
    <span class="d-block mt-2" v-if="!image">{{placeHolder}}</span>
    <input :ref="refName" @input="onSelectFile" class="file-input" hidden type="file" accept="image/*">
  </div>
</template>

<script>
import { kebabCase } from "lodash";
import NoImageUpload from "@/assets/images/NoImageUpload.png"
import NoImage from "@/assets/images/NoImage.png"
export default {
  name: "BaseUploadImage",
  props: {
    label: String,
    image: {
      type: String,
      default: null
    },
    isDisabled: {
      type: Boolean,
      default: false
    },
    isAcoutUser: {
      type: Boolean,
      default: false
    },
  },
  data() {
    return {
      NoImageUpload: NoImageUpload,
      NoImage: NoImage
    };
  },
  computed: {
    placeHolder() {
      return `Tải lên ${this.label}`;
    },
    refName() {
      return this.getKey(this.label);
    }
  },
  methods: {
    getKey(value) {
      if (!this.isDisabled) return kebabCase(value);
    },
    chooseImage() {
      if (!this.isDisabled) this.$refs[this.refName].click();
    },
    onSelectFile() {
      const input = this.$refs[this.refName];
      const files = input.files;
      if (files && files[0]) {
        if (!this.isDisabled) this.$emit("input", files[0]);
      }
    }
  }
};
</script>

<style lang="scss">
.b-avatar-badge {
  font-size: calc(0.96em) !important;
  cursor: pointer;
}
.b-avatar .b-avatar-img img {
  height: auto !important;
}
.customs-image {
  max-width: 6em;
  height: auto;
  background: transparent
}
.image {
  max-width: 8em;
  background: transparent
}
</style>
